import { render, staticRenderFns } from "./view-account.vue?vue&type=template&id=57eabdea"
import script from "./view-account.vue?vue&type=script&lang=js"
export * from "./view-account.vue?vue&type=script&lang=js"
import style0 from "./view-account.vue?vue&type=style&index=0&id=57eabdea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports